var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.75 5.5H4.58333H19.25",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4166 5.50016V18.3335C17.4166 18.8197 17.2234 19.286 16.8796 19.6299C16.5358 19.9737 16.0695 20.1668 15.5833 20.1668H6.41659C5.93035 20.1668 5.46404 19.9737 5.12022 19.6299C4.77641 19.286 4.58325 18.8197 4.58325 18.3335V5.50016M7.33325 5.50016V3.66683C7.33325 3.1806 7.52641 2.71428 7.87022 2.37047C8.21404 2.02665 8.68035 1.8335 9.16659 1.8335H12.8333C13.3195 1.8335 13.7858 2.02665 14.1296 2.37047C14.4734 2.71428 14.6666 3.1806 14.6666 3.66683V5.50016",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.16675 10.0835V15.5835",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.8333 10.0835V15.5835",
    stroke: "#868686",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash-2.cb519c9dd80cb5e311a376921c2877ee.svg";
export { ForwardRef as ReactComponent };